import React, { useEffect, useState } from 'react';
import { BasicDetailItem } from '../../../common/BasicDetailItem';
import '../accounts.scss';

export const AccountsReadOnly = ({ preferences: preferencesOld }) => {
  const [preferences, setPreferences] = useState(preferencesOld);

  useEffect(() => {
    setPreferences(preferencesOld);
  }, []);

  return (
    <>
      <div className='about-me-prefs' style={{ color: '#2E2B2B' }}>
        <BasicDetailItem label={'PayPal'} value={preferences?.email_paypal ?? ''} makeFirstCharCapital={false}/>
        <BasicDetailItem label={'Venmo'} value={preferences?.email_venmo ?? ''} makeFirstCharCapital={false}/>
      </div>
    </>
  );
};
